import React, { useState, useEffect } from "react";
import { useObjectStore } from "../zustand/objects";
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import ShareModal from './ShareModal';

import {Box} from "@mui/material/";
import { ActionIcon, Tooltip } from '@mantine/core';

 
const SharePreviewButton = ({projectKey, iconColour
}) => {

  const {
    switchShareModalOpen
  } = useObjectStore();

  const [show, setShow] = useState(false);
  const [showText, setShowText] = useState(false);
  const [divWidth, setDivWidth] = useState(50);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    show ? setDivWidth(90) : setDivWidth(60)
  })

  const handleClose = () => {
    setShow(false);
    setShowText(false);
  };

  return (<>

  <Tooltip label="Configure sharing">
      <ActionIcon
        variant='transparent'
        color={!hover ? iconColour.normal : iconColour.hover}
        onPointerOver={() => setHover(true)}
        onPointerLeave={() => setHover(false)}
        onClick={() => {
          switchShareModalOpen()
        }}>
        <ShareOutlinedIcon style={{ width: '80%', height: '80%' }}/>
      </ActionIcon></Tooltip>

    <ShareModal projectKey={projectKey} />
</>
  );
};

export default SharePreviewButton;
